import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DataService, ServicecallService } from 'src/app';
import { ApiConstants } from 'src/app/constants/api-constants';
import { Messages } from 'src/app/constants/messages';
import { AggregateCategoryResponse, DataBroadcast, DataBroadcastModel } from 'src/app/model';
import { EntitiesServiceService } from 'src/app/shared/services';

@Component({
  selector: 'app-entity-categories',
  templateUrl: './entity-categories.component.html',
  styleUrl: './entity-categories.component.css'
})
export class EntityCategoriesComponent implements OnInit, OnDestroy {

  @Input() pageType: string;
  @Output() collapse = new EventEmitter<any>();
  @Output() filterValue = new EventEmitter<any>();

  private _widgetData: any;
  private _intervalTimer: any;
  public token: string = ApiConstants?.blobSasToken;
  private clickTimeout: any;
  public selectedCategory: string = null;
  private _tenantGenericConfig : any;
  private _subscription: Subscription;
  rangeApplied: string = 'Yesterday';

  @Input()
  set widgetData(value: any) {
    this._widgetData = value;
  }

  get widgetData() {
    return this._widgetData;
  }

  private _entitiesAggrSubscription: Subscription;
  private _entitiesFromChart: string[];


  entityCategories: { category: string, icon: string, distanceLabel: string, operatingHoursLabel: string, totalDistance: number, totalEngineHours: number, entityCount: number, totalDistanceTrimmed: number, totalEnginehoursTrimmed: number }[] = [];

  //Mock API Response
  categoryVehicleData: any[] = [];

  constructor(private _entitiesService: EntitiesServiceService, private _service: ServicecallService, private _datePipe: DatePipe, private _router: Router, private _dataSer: DataService) {
    this._subscription = this._dataSer.events
    .subscribe({
      next: (broadcast: DataBroadcastModel) => {
        if (broadcast.name === DataBroadcast?.SITE_CHANGED || broadcast.name === DataBroadcast.API_REFRESH || broadcast.name === DataBroadcast.ENTITYLISTDATETIMEAPPLIED) {
          this._calculateAggregate(true);
        }
        if(broadcast?.name === DataBroadcast.DATETIMERANGEAPPLIED) {
          this.rangeApplied = broadcast?.args?.[1]?.rangeSelected;
          this._calculateAggregate(true);
        }
      }
    });
   }

  ngOnInit(): void {
    this.rangeApplied = this._service.getRangeSelected() || 'Yesterday';
    this.entityCategories = this._service.getConfiguration('tenantGenericConfig') ? this._service.getConfiguration('tenantGenericConfig')?.segments : [];
    this._tenantGenericConfig = this._service.getConfiguration('tenantGenericConfig') ? this._service.getConfiguration('tenantGenericConfig') : null;
    if(this._service.getEntitiesFilter()?.length){
      this._entitiesFromChart = this._service.getEntitiesFilter();
    }
    this._calculateAggregate(true);
    if (this.pageType === "home") {
      this._refreshApi();
    }
  }

  /**
  * Calculates aggregate
  */
  private _calculateAggregate(loader: boolean) {
    const defaultStartDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 999);
    const reqPayload: any = { entityIds: this._entitiesFromChart?.length ? this._entitiesFromChart : [], groupBy: "category" };
    let configStartDate = null;
    let configEndDate = null;
    if(this._service.getSiteId()){
      reqPayload.siteId = this._service.getSiteId();
    }
    if (this.pageType === "home") {
      if (this._tenantGenericConfig?.defaultTimeRange) {
        const { startDate, endDate } = this._service.getConfigStartAndEndDate(this._tenantGenericConfig?.defaultTimeRange);
        configStartDate = startDate;
        configEndDate = endDate;
      }
    } else {
      if (this._tenantGenericConfig?.defaultTimeRange) {
        const configHour = this._tenantGenericConfig?.defaultTimeRange || 0;
        const { startDate, endDate } = this._service.calculateDateRange(configHour);
        configStartDate = startDate;
        configEndDate = endDate;
      }
    }
    reqPayload.from = this._datePipe.transform(configStartDate ?? defaultStartDate, 'yyyy-MM-ddTHH:mm:ssZZ')
    reqPayload.to = this._datePipe.transform(configEndDate ?? Date.now(), 'yyyy-MM-ddTHH:mm:ssZZ')
    if(this.pageType !== 'home' && this._tenantGenericConfig?.excludeFromFieldInFilters) {
      reqPayload.excludeFromFieldInFilters = this._tenantGenericConfig?.excludeFromFieldInFilters;
    }
    this._entitiesAggrSubscription = this._entitiesService.getEntityAggrSummary(reqPayload, loader, this.pageType === 'home'? 'widget': 'vehicleList').subscribe({
      next: (result: AggregateCategoryResponse[]) => {
        if (result?.length) {
          this.categoryVehicleData = [...result];
          this.entityCategories = this.entityCategories?.map((item: { category: string, icon: string, distanceLabel: string, operatingHoursLabel: string, totalDistance: number, totalEngineHours: number, entityCount: number }) => {
            const totalDistance = this.categoryVehicleData?.find((i: any) => i.category === item.category)?.totalDistance?.toFixed(3) ?? 0;
            const totalEngineHours = this.categoryVehicleData?.find((i: any) => i.category === item.category)?.totalEngineHours?.toFixed(3) ?? 0;
            const entityCount = this.categoryVehicleData?.find((i: any) => i.category === item.category)?.entityCount ?? 0;
            const totalDistanceTrimmed = Number(Math.floor(totalDistance));
            const totalEnginehoursTrimmed= Number(Math.floor(totalEngineHours));
            return {
              ...item,
              totalDistance,
              totalEngineHours,
              entityCount,
              totalDistanceTrimmed,
              totalEnginehoursTrimmed
            }
          })
        } else {
          this.categoryVehicleData = [];
        }
        if (this.pageType === "home") {
          this._refreshApi();
        }
      },
      error: (error) => {
        this._service.toasterService({ type: 'error', msg: Messages.ERROR });
        if (this.pageType === "home") {
          this._refreshApi();
        }
      }
    });
  }


  ngOnDestroy(): void {
    if (this.pageType === "home") {
      this._clearTimer();
    }
    this._entitiesAggrSubscription?.unsubscribe();
    this._subscription?.unsubscribe();
    this._service.setEntitiesFilter([]);
  }

  /**
   * Handles single click
   * @param value 
   * @returns  
   */
  public handleClick(value: { category: string; icon: string; entityCount: number; totalDistance: number, totalEngineHours: number }) {
    if (this.clickTimeout) {
      return; // Prevent triggering single-click on double-click
    }
    this.clickTimeout = setTimeout(() => {
      this.clickTimeout = null;
      if (!this.selectedCategory || value?.category !== this.selectedCategory ) {
        this.selectedCategory = value?.category;
        this.collapse.emit('applyFilter');
        this.filterValue.emit({ "filterFields": { "category": [value?.category] } });
      } else {
        this.selectedCategory = null;
        this.filterValue.emit({ "filterFields": { "category": [null] } });
      }
    }, 300); // Adjust delay to differentiate between single and double clicks
  }

  /**
   * Handles double click
   * @param value 
   */
  public onDoubleClick(value: { category: string; icon: string; entityCount: number; totalDistance: number, totalEngineHours: number }) {
    clearTimeout(this.clickTimeout); // Cancel the single click handler
    this.clickTimeout = null;
    if (this.pageType === 'home') {
      this._router.navigateByUrl('/vehicles/active?type=' + value?.category)
    }
  }

  /**
* Refreshs api
*/
  private _refreshApi() {
    if ((this._tenantGenericConfig?.tenant === 'VOT' && this.pageType === "home" ) ? ((this.rangeApplied !== 'Yesterday' && this.rangeApplied !== 'Custom') ? +this.widgetData?.attributes?.refreshRate : 0) : +this.widgetData?.attributes?.refreshRate) {
      this._clearTimer();
      this._intervalTimer = setInterval(() => {
        this._calculateAggregate(false);
      }, +this.widgetData?.attributes?.refreshRate);
    } else {
      this._clearTimer();
    }
  }

  /**
   * Clears timer
   */
  private _clearTimer() {
    if (this._intervalTimer) {
      clearInterval(this._intervalTimer);
    }
  }

}
